// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Loader_Loader__2m9_F","Label":"Loader_Label__1jSTK","Spinner":"Loader_Spinner__3deR1","load6":"Loader_load6__3TaL4","round":"Loader_round__2t0-C"};